module.exports = __webpack_public_path__ + "static/img/yorkton3.9019572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/yorkton3.jpg
// module id = 155
// module chunks = 9